var React = require('react');

function SubtractInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M20.732233,5.73223305 C21.7085438,4.75592232 23.2914562,4.75592232 24.267767,5.73223305 C25.2440777,6.70854378 25.2440777,8.29145622 24.267767,9.26776695 L9.26776695,24.267767 C8.29145622,25.2440777 6.70854378,25.2440777 5.73223305,24.267767 C4.75592232,23.2914562 4.75592232,21.7085438 5.73223305,20.732233 L20.732233,5.73223305 Z","transform":"rotate(45 29.589 7.543)"}));
}

SubtractInline.defaultProps = {"width":"28","height":"5","viewBox":"0 0 28 5"};

module.exports = SubtractInline;

SubtractInline.default = SubtractInline;
